import { Reveal } from "./Reveal";

export default function DevelopmentLoop({ stages }) {
    return (
        <div data-testid="platform-diagram" className="relative">
            <div className="hidden lg:block">
                <div className="flex items-stretch">
                    {stages.map((s, i) => (
                        <div key={s.n} className="flex flex-1 flex-col">
                            <Reveal delay={i * 0.08}>
                                <div className="flex h-10 items-center">
                                    <span className="flex h-9 w-9 items-center justify-center rounded-full border border-blue-bright/60 font-mono text-[11px] text-blue-bright">
                                        {s.n}
                                    </span>
                                </div>
                            </Reveal>
                            {i < stages.length - 1 ? (
                                <div className="relative my-2 h-px w-[calc(100%-2.25rem)] ml-[2.25rem] bg-blue-bright/30">
                                    <span aria-hidden="true" className="absolute -right-1 top-1/2 -translate-y-1/2 h-2 w-2 rotate-45 border-r border-t border-blue-bright/60" />
                                </div>
                            ) : null}
                            <div className="pr-6 pt-4">
                                <h3 className="font-display text-[15px] font-semibold uppercase tracking-[0.08em] text-white">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-[13px] leading-relaxed text-white/55">{s.body}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <svg viewBox="0 0 1000 90" className="mt-10 w-full" preserveAspectRatio="none" aria-hidden="true">
                    <path d="M 985 4 C 985 72, 15 72, 15 4" fill="none" stroke="#4C7FBE" strokeOpacity="0.45" strokeWidth="1" strokeDasharray="5 7" className="flow-line" />
                    <path d="M 10 14 L 15 4 L 20 14" fill="none" stroke="#4C7FBE" strokeOpacity="0.7" strokeWidth="1.2" />
                </svg>
                <p className="mt-1 text-center font-mono text-[11px] uppercase tracking-[0.24em] text-white/40">
                    A continuous development cycle — capital returns to origination
                </p>
            </div>

            <div className="relative lg:hidden">
                <span aria-hidden="true" className="absolute left-[17px] top-2 bottom-2 w-px bg-blue-bright/30" />
                <ul className="space-y-10">
                    {stages.map((s, i) => (
                        <li key={s.n} className="relative pl-14">
                            <Reveal delay={0.05}>
                                <span className="absolute left-0 top-0 flex h-9 w-9 items-center justify-center rounded-full border border-blue-bright/60 bg-navy font-mono text-[11px] text-blue-bright">
                                    {s.n}
                                </span>
                                <h3 className="font-display text-base font-semibold uppercase tracking-[0.08em] text-white">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-white/55">{s.body}</p>
                            </Reveal>
                        </li>
                    ))}
                </ul>
                <div className="relative mt-10 pl-14">
                    <svg viewBox="0 0 24 60" className="absolute left-[11px] -top-8 h-16 w-6" aria-hidden="true">
                        <path d="M 12 0 C 12 30, 12 30, 12 44" fill="none" stroke="#4C7FBE" strokeOpacity="0.45" strokeWidth="1" strokeDasharray="5 7" />
                    </svg>
                    <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-white/40">↺ The cycle returns to origination</p>
                </div>
            </div>
        </div>
    );
}
